import React from 'react';
import styled from 'styled-components';
import { useMatches } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '../../../../../store';
import { DataElementContext } from '../../../../../page-components/common/DataElementContext';
import { testValues, sportNameToId } from '../../utils/functions';
import { SportType } from '../../utils/types';
import { prematchFetchSportByDay } from '../../../../../modules/bets/store/actions/prematch';
import { navSportsUpdate } from '../../../../../modules/bets/store/actions/navSports';

import './index.scss';

type NavigatorProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: {
    dsType: string;
  };
};

const defaultProps = {
  className: '',
  styleText: '',
  properties: {
    dsType: '',
  },
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const Navigator = (componentProps: NavigatorProps) => {
  const uriMatches = useMatches();
  const dispatch = useAppDispatch();
  const sportsMeta = useAppSelector<any>((state) => state.bets.prematch.sportsMeta);
  const filterByDate = useAppSelector<any>((state: any) => state.bets.calendar.filterBy);
  const filterByRange = useAppSelector<any>((state: any) => state.bets.calendar.range);
  const [extraTotal, setExtraTotal] = React.useState(0);
  const tid = React.useRef<any>(0);
  const dataElementContext = React.useContext(DataElementContext);

  //console.log('Navigator[sportsMeta]', sportsMeta, filterByDate);

  let sports: SportType[] = Object.values(sportsMeta);

  // only active sports
  sports = sports.filter((sport: SportType) => {
    return sport?.sportActive === true;
  });

  // sort sport by backend sport position
  sports.sort((a, b) => {
    return testValues(a?.sportPosition, b?.sportPosition);
  });

  let idSport = '';
  if (uriMatches?.length > 0) {
    uriMatches.find((match: any) => {
      if (match.params?.idSport) {
        idSport = match.params.idSport;
        return true;
      }
      return false;
    });
  }

  if (idSport) idSport = sportNameToId(idSport);
  if (!idSport) idSport = '1';

  let selectedIndexSport = -1;
  let selectedSport = null;
  if (idSport) {
    selectedSport = sports.find((sport: SportType, index: number) => {
      if (sport?.idSport === idSport) {
        selectedIndexSport = index;
      }
      return sport?.idSport === idSport;
    });
  }

  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    if (e.currentTarget.dataset.sport) {
      const sport = e.currentTarget.dataset.sport;
      dispatch(navSportsUpdate('prematch', sport));

      let noDays = 1;
      if (filterByRange === '72h') {
        noDays = 3;
      }

      dispatch(prematchFetchSportByDay({ idSport: sport, day: filterByDate, noDays: noDays }));
    }
  };

  const handleResize = (timeout: any) => {
    window.clearTimeout(tid.current);
    tid.current = window.setTimeout(
      () => {
        let baseTop = 0;
        let items: any = document.querySelectorAll('.wl-prematch-navigator.mobile>.list-wrapper>.list>.item-wrapper');
        if (items.length) baseTop = items[0].offsetTop;

        const total = sports.length;
        let extraTotal = 0;

        if (items) {
          items = Array.from(items);
          items.find((item: any, index: number) => {
            if (item.offsetTop > baseTop) {
              extraTotal = total - index;
              return true;
            }

            return false;
          });

          setExtraTotal(extraTotal);
        }
      },
      typeof timeout === 'number' ? timeout : 100,
    );
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    handleResize(10);
  }, [sportsMeta, filterByDate]);

  const contextValue = {
    sports,
    selectedSport,
    hiddenSport:
      selectedIndexSport > -1 && sports.length && extraTotal > 0 && selectedIndexSport >= sports.length - extraTotal
        ? true
        : false,
    extraTotal,
    onClick: onClick,
    parentContext: dataElementContext,
  };

  //console.log('Navigator[contextValue]', contextValue);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Navigator;
